<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">{{options?.title}}</h4>
</div>
<div class="modal-body">
  <p [innerHTML]="$safeNavigationMigration(options?.body)"></p>
  @if (options?.multiChoiceType == choiceType.DropDown) {
    <div>
      <select class="form-control" [(ngModel)]="selectedElement" id="ddlOptions" [bizFocus]="true">
        @for (element of options?.elements; track element) {
          <option [ngValue]="element">{{element.elementText}}</option>
        }
      </select>
    </div>
  }
  @if (options?.multiChoiceType == choiceType.RadioButtons) {
    <div>
      <!-- TODO: Implement -->
    </div>
  }
  @if (options?.multiChoiceType == choiceType.CheckBoxes) {
    <div>
      @for (element of options?.elements; track element) {
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="element.selected"> {{element.elementText}}
          </label>
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" id="btnOk" class="btn btn-primary" (click)="ok()">{{options?.okButtonText || 'Ok'}}</button>
  <button type="button" id="btnCancel" class="btn btn-secondary" (click)="close()">{{options?.cancelButtonText || 'Cancel'}}</button>
</div>